import {Popover, Stack, Button, Heading} from '@primer/react'
import {useClickAnalytics} from '@github-ui/use-analytics'
import styles from './CCAPopover.module.css'

export function CCAPopover({showPopover, dismissPopover}: {showPopover: boolean; dismissPopover: () => void}) {
  const {sendClickAnalyticsEvent} = useClickAnalytics()
  if (!showPopover) {
    return null
  }

  const handleLearnMoreClick = () => {
    sendClickAnalyticsEvent({
      category: 'copilot-coding-agent-popover',
      action: 'learn-more',
      tag: 'link',
      group: 'expand',
      location: 'global-copilot-menu',
    })
  }

  const handleDismissClick = () => {
    sendClickAnalyticsEvent({
      category: 'copilot-coding-agent-popover',
      action: 'dismiss',
      tag: 'button',
      group: 'expand',
      location: 'global-copilot-menu',
    })
    dismissPopover()
  }
  return (
    <Popover open={showPopover} caret="top" className={styles.popover}>
      {/* eslint-disable-next-line primer-react/no-system-props */}
      <Popover.Content
        overflow="visible"
        className={styles.popover_content}
        data-analytics-visible={JSON.stringify({
          category: 'copilot-coding-agent-popover',
          action: 'visible',
          group: 'expand',
          location: 'global-copilot-menu',
        })}
      >
        <Heading as="h3" variant="small" className="h5 mb-1">
          Start a task with Copilot coding agent
        </Heading>
        <p>
          Describe your task in natural language. Copilot will work in the background and open a pull request for your
          review.
        </p>
        <Stack className="mt-2" direction="horizontal" gap="condensed">
          <Button
            as="a"
            href="https://docs.github.com/copilot/concepts/coding-agent/coding-agent"
            aria-label="Learn more about Copilot coding agent"
            onClick={handleLearnMoreClick}
          >
            Learn more
          </Button>
          <Button variant="invisible" onClick={handleDismissClick}>
            Dismiss
          </Button>
        </Stack>
      </Popover.Content>
    </Popover>
  )
}

try{ CCAPopover.displayName ||= 'CCAPopover' } catch {}